export var getIsSizeLarge = function getIsSizeLarge(size) {
  return size === 'large';
};